// PageHeader — en-tête d'écran STANDARD du back-office (Design System commun).
// Fournit : titre, sous-titre explicatif, barre d'actions, rangée de statistiques (KPIs)
// et aide contextuelle (popover). Un seul composant → uniformité sur tous les écrans admin.
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './PageHeader.css';

const PageHeader = ({
  title,
  subtitle,
  actions,            // ReactNode (boutons à droite)
  stats,              // [{ label, value, icon?, tone? }]
  help,               // ReactNode / string : contenu d'aide (popover)
  icon,               // emoji / élément décoratif optionnel
}) => {
  const { t } = useTranslation('common');
  const [openHelp, setOpenHelp] = useState(false);
  const helpRef = useRef(null);

  useEffect(() => {
    if (!openHelp) return;
    const onDoc = (e) => { if (helpRef.current && !helpRef.current.contains(e.target)) setOpenHelp(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [openHelp]);

  return (
    <header className="page-header">
      <div className="page-header__top">
        <div className="page-header__titles">
          <h1 className="page-header__title">
            {icon && <span className="page-header__icon" aria-hidden="true">{icon}</span>}
            {title}
            {help && (
              <span className="page-header__help" ref={helpRef}>
                <button
                  type="button"
                  className="page-header__help-btn"
                  aria-label={t('ui.help', 'Aide')}
                  aria-expanded={openHelp}
                  onClick={() => setOpenHelp((v) => !v)}
                >?</button>
                {openHelp && <div className="page-header__help-pop" role="tooltip">{help}</div>}
              </span>
            )}
          </h1>
          {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </div>

      {Array.isArray(stats) && stats.filter(Boolean).length > 0 && (
        <div className="page-header__stats">
          {/* 🛡️ on ignore les entrées null/undefined (stats assemblées conditionnellement). */}
          {stats.filter(Boolean).map((s, i) => (
            <div key={i} className={`ph-stat ph-stat--${s.tone || 'default'}`}>
              {s.icon && <span className="ph-stat__icon" aria-hidden="true">{s.icon}</span>}
              <div className="ph-stat__body">
                <span className="ph-stat__value">{s.value}</span>
                <span className="ph-stat__label">{s.label}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </header>
  );
};

export default PageHeader;
